export const normalizeRecordIdentifier = (value?: string | null) =>
  (value ?? "").replace(/\D/g, "")

export const isCedulaIdentifier = (value?: string | null) =>
  normalizeRecordIdentifier(value).length === 11

export const isRncIdentifier = (value?: string | null) =>
  normalizeRecordIdentifier(value).length === 9

export const buildRecordPath = (value?: string | null) =>
  `/record/${normalizeRecordIdentifier(value)}`
